





































































































































































import Vue from 'vue'
import _ from 'lodash'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow, DxGrouping, DxGroupPanel,
  DxScrolling,
  DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import { FETCH_COMMISSION_GROUP, FETCH_SEARCH_COMMISSION_LIST } from '@/store/action-types'
import CommissionWindow from '@/components/master-data/commissions/CommissionWindow.vue'
import { KommissionSearchResponse, } from '@/types/service-response'
import { KommissionSearchRequest } from '@/types/payload'
import { SearchCommission } from '@/model/commissions/SearchCommission'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"
import moment from 'moment'
import { CommissionGroup } from '@/model/commissions/CommissionGroup'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import { TranslateResult } from 'vue-i18n'
import { Commission } from '@/model/commissions/Commission'
import { KeyAction } from '@/model/KeyAction'
import { keyActionService } from '@/services/key-action-service'

class SelectAll extends KeyAction {}

interface ComponentData {
  tableHeight: string,
  loading: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  showDialog: boolean
  dateRules: any[]

  commissionArtList: CommissionGroup[]
  commissionIdList: number[]
  commissionList: SearchCommission[]
  isDetailButtonDisabled: boolean

  nummer: string
  bezeichnung: string
  menu1: boolean
  menu2: boolean
  start: string | null
  startFormatted: string | null
  end: string | null
  endFormatted: string | null
  addressName: string
  sachbearbeiter: string
  fach: string
  bemerkungen: string
  kommissiongruppe: string | null
  commissionStatus: string

  maxRecords: number
  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'CommissionsSearchPage',

  components: {
    CommissionWindow,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring
  },

  props: {
    commissionGroupId: String
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      loading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      showDialog: false,
      dateRules: [
        (value: string | null) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value && value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true
        }
      ],

      commissionArtList: [],
      commissionIdList: [],
      commissionList: [],
      isDetailButtonDisabled: true,

      nummer: '',
      bezeichnung: '',
      menu1: false,
      menu2: false,
      start: null,
      startFormatted: null,
      end: null,
      endFormatted: null,
      addressName: '',
      sachbearbeiter: '',
      fach: '',
      bemerkungen: '',
      kommissiongruppe: null,
      commissionStatus: '1',

      maxRecords: 500,
      keyActions: []
    }
  },

  watch: {
    $route (newVal: any): void {
      if(newVal.query.create) {
        this.commissionIdList = [0]
        this.showDialog = true
      }

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    },

    commissionGroupId (newVal: string): void {
      if(newVal) {
        this.kommissiongruppe = newVal
      }
    },

    startFormatted (newVal: string | null): void {
      if(newVal) {
        this.start = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : null
      } else {
        this.start = null
      }
    },

    endFormatted (newVal: string | null): void {
      if(newVal) {
        this.end = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : null
      } else {
        this.end = null
      }
    }
  },

  computed: {
    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: SelectAll | null): boolean {
      if(action instanceof SelectAll) {
        return !this.showDialog
      } else {
        return false
      }
    },

    selectAll (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }
      //@ts-ignore
      this.$refs.dataGrid.instance.selectAll()
    },

    formatDate(item: string): string {
      return moment(item, 'DD.MM.YYYY HH:mm:ss').isValid() ? moment(item, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY') : ''
    },

    formatDateToDate(item: string): string {
      return moment(item, 'DD.MM.YYYY HH:mm:ss').isValid() ? moment(item, 'DD.MM.YYYY HH:mm:ss').toISOString() : ''
    },

    onDateStartChange (date: string): void {
      this.startFormatted = moment(date).format('DD.MM.YYYY')
    },

    onDateEndChange (date: string): void {
      this.endFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurStart (): void {
      this.startFormatted = this.start && moment(this.start).isValid() ? moment(this.start).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onBlurEnd (): void {
      this.endFormatted = this.end && moment(this.end).isValid() ? moment(this.end).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu2) {
          this.menu2 = false
        }
      }, 100)
    },

    startCreate (): void {
      this.commissionIdList = [0]
    },

    commissionCopy (commission: Commission): void {
      this.commissionIdList.push(commission.id)
      this.commissionList.push(commission)
    },

    commissionCreated (commission: Commission): void {
      this.commissionIdList = [commission.id]
      this.commissionList.push(commission)
    },

    commissionEdited (): void {
      this.searchCommission()
    },

    commissionDeleted (id: number) : void {
      this.commissionIdList.splice(this.commissionIdList.indexOf(id), 1)
      if(this.commissionIdList.length === 0) {
        this.showDialog = false
        let ruteData: any = this.getRouteData()
        ruteData.selectedRowKeys = []
        ruteData.showDialog = this.showDialog
        this.$router.push({name: 'CommissionsSearch', query: { data: JSON.stringify(ruteData) }})
        this.searchCommission()
      } else {
        this.searchCommission()
      }
    },

    onCloseDialog (): void {
      this.showDialog = false
      this.commissionIdList = []
      if(this.commissionGroupId) {
        this.$router.push({ path: `/commissions/${this.commissionGroupId}`})
      } else {
        this.$router.push({ path: '/commissions'})
      }
    },

    onSearchButtonClick (): void {
      this.commissionList = []

      let data: any = this.getRouteData()

      data.nummer = this.nummer
      data.bezeichnung = this.bezeichnung
      data.start = this.start
      data.end = this.end
      data.addressName = this.addressName
      data.sachbearbeiter = this.sachbearbeiter
      data.fach = this.fach
      data.bemerkungen = this.bemerkungen
      data.commissionStatus = this.commissionStatus

      this.$router.push({name: 'CommissionsSearch', query: { data: JSON.stringify(data) }})

      this.searchCommission()
    },

    onSelectionChanged (data: any) {
      this.isDetailButtonDisabled = data.selectedRowKeys.length <= 0

      let ruteData: any = this.getRouteData()
      ruteData.selectedRowKeys = data.selectedRowKeys
      this.$router.push({name: 'CommissionsSearch', query: { data: JSON.stringify(ruteData) }})
    },

    rowDblClick(event: any): void {
      this.commissionIdList.push(event.data.id)
      this.showDialog = true

      let ruteData: any = this.getRouteData()
      ruteData.selectedRowKeys = [event.data.id]
      ruteData.showDialog = this.showDialog
      this.$router.push({name: 'CommissionsSearch', query: { data: JSON.stringify(ruteData) }})
    },

    onDetailClick (): void {
      //@ts-ignore
      const selectedCommissionIdList: number[] = this.$refs.dataGrid.instance.getSelectedRowKeys()

      if(selectedCommissionIdList.length > 0) {
        this.commissionIdList = selectedCommissionIdList
        this.showDialog = true

        let ruteData: any = this.getRouteData()
        ruteData.showDialog = this.showDialog
        this.$router.push({name: 'CommissionsSearch', query: { data: JSON.stringify(ruteData) }})
      }
    },

    onResize (): void {
      if(this.$refs.filter && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.filter as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 100px - ${height}px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    },

    async searchCommission (): Promise<void> {
      const payload: KommissionSearchRequest = {
        ID: null,
        Nummer: this.nummer,
        Bezeichnung: this.bezeichnung,
        GenAdresse: this.addressName,
        SachbearbeiterVollerName: this.sachbearbeiter,
        Fach: this.fach,
        Start: this.start ? this.start : '',
        Termin: this.end ? this.end : '',
        Bemerkungen: this.bemerkungen,
        Status: this.commissionStatus === '1' ? 'aktiv' : this.commissionStatus === '2' ? 'passiv' : 'alle',
        Art: this.kommissiongruppe!,
        KommissionZusatzfelderSearchItems: [],
        Mitarbeiter: this.currentUserId,
        Sprache: this.selectedLanguageId,
        MaxRecords:  this.maxRecords,
      }

      try {
        this.loading = true
        const response: KommissionSearchResponse = await this.$store.dispatch(FETCH_SEARCH_COMMISSION_LIST, payload)
        if(!response.IsError && response.Results) {
          this.commissionList = SearchCommission.createListFromResponse(response.Results)

          let data: any = this.getRouteData()
          if(this.$route.path === '/commissions' && data.selectedRowKeys) {
            let selectedRowKeyList: number[] = []
            this.commissionList.forEach((item: SearchCommission) => {
              if(data.selectedRowKeys.includes(item.id)) {
                selectedRowKeyList.push(item.id)
              }
            })

            setTimeout(() => {
              //@ts-ignore
              this.$refs.dataGrid.instance.selectRows(selectedRowKeyList)
              this.showDialog = data.showDialog !== undefined && selectedRowKeyList.length > 0 ? data.showDialog : false
            }, 100)
          }
        }
      } catch {

      } finally {
        this.loading = false
      }
    },

    async fetchCommissionArtList (): Promise<void> {
      try {
        this.commissionArtList = await this.$store.dispatch(FETCH_COMMISSION_GROUP)
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    setDataFromRoute () {
      let data: any = this.getRouteData()

      if(this.$route.path === '/commissions') {
        this.nummer = data && data.nummer ? data.nummer : ''
        this.bezeichnung = data && data.bezeichnung ? data.bezeichnung : ''
        this.start = data && data.start && moment(data.start).isValid() ? data.start : null
        this.end = data && data.end && moment(data.end).isValid() ? data.end : null
        this.startFormatted = this.start ? moment(this.start).format('DD.MM.YYYY') : null
        this.endFormatted = this.end ? moment(this.end).format('DD.MM.YYYY') : null
        this.addressName = data && data.addressName ? data.addressName : ''
        this.sachbearbeiter = data && data.sachbearbeiter ? data.sachbearbeiter : ''
        this.fach = data && data.fach ? data.fach : ''
        this.bemerkungen = data && data.bemerkungen ? data.bemerkungen : ''
        this.commissionStatus = data && data.commissionStatus ? data.commissionStatus : '1'

        this.commissionIdList = data.selectedRowKeys ? data.selectedRowKeys : []

        if(!_.isEmpty(data)) {
          this.searchCommission()
        }
      }
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  beforeMount () {
    this.keyActions = [
      new SelectAll(KeyActionEnum.selectAll, this.selectAll, this.resolver,  null)
    ]
  },

  mounted (): void {
    window.addEventListener('keydown', this.onKeydown)

    this.fetchCommissionArtList()
    this.setDataFromRoute()
    if(this.$route.query.create) {
      this.commissionIdList = [0]
      this.showDialog = true
    }

    if(this.commissionGroupId) {
      this.kommissiongruppe = this.commissionGroupId
    }

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
